<ng-container *ngIf="(branding$ | async)?.logo as brandingLogo">
  <img
    [src]="'data:image/png;base64, ' + brandingLogo"
    alt="Company logo"
    width="100%"
    height="auto"
    (click)="logoClicked.emit()" />
</ng-container>
